export const svgUrl = (name: string) => `/assets/images/${name}.svg`
